module.exports = __webpack_public_path__ + "static/media/Logo.b18519d5.svg";